/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driver_No_MatchInputs */

const vi_driver_no_match = /** @type {(inputs: Driver_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có đơn nào khớp từ khoá`)
};

/**

* @param {Driver_No_MatchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const driver_no_match = /** @type {((inputs?: Driver_No_MatchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driver_No_MatchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driver_no_match(inputs)
});